import {
    BANNERS_ADD,
    BANNERS_FETCH,
    BANNERS_EDIT,
    BANNERS_REMOVE,
    BANNERS_ERROR
} from "../store/types";
import { firebase } from "../config/firebase.client";
import { onValue, update, remove, push } from "firebase/database";
import { uploadBytesResumable, getDownloadURL, ref, deleteObject } from "firebase/storage";

export const fetchBanners = () => async (dispatch) => {
    const { bannersRef } = firebase;
    try {

        const snapshot = await new Promise((resolve, reject) => {
            onValue(bannersRef, (snapshot) => {
                resolve(snapshot);
            }, {
                onlyOnce: true
            });
        });

        if (snapshot.exists()) {
            const bannersData = snapshot.val();

            const bannersArray = Object.keys(bannersData).map((key) => ({
                ...bannersData[key],
                ref: key,
            }));

            bannersArray.sort((a, b) => b.createdAt - a.createdAt);


            dispatch({
                type: BANNERS_FETCH,
                payload: bannersArray,
            });
        } else {
            throw new Error('Document not found');
        }
    } catch (error) {
        console.error('Error fetching banners data:', error);
        dispatch({
            type: BANNERS_ERROR,
            payload: error.message,
        });
    }
};

export const editBanners = (banners, method, img) => async (dispatch) => {
    const { bannersAddRef, bannersEditRef, bannersImage } = firebase;

    if (method === "Add") {
        const newAdRef = push(bannersAddRef, banners);;
        const newAdData = { ...banners, ref: newAdRef.key };
        dispatch({
            type: BANNERS_ADD,
            payload: newAdData,
        });
    }
    else if (method === "Delete") {
        remove(bannersEditRef(banners.ref), banners);

        const imageRef = ref(bannersImage(banners.ref));

        await deleteObject(imageRef);

        dispatch({
            type: BANNERS_REMOVE,
            payload: banners,
        });
    }
    else if (method === "Update") {
        update(bannersEditRef(banners.ref), banners);

        dispatch({
            type: BANNERS_EDIT,
            payload: banners,
        });
    }
    else if (method === "UpdateImage") {
        await uploadBytesResumable(bannersImage(banners.ref), img);
        let image = await getDownloadURL(bannersImage(banners.ref));


        const NewDate = {
            ...banners,
            tableData: null,
            photoUrl: image
        }

        update(bannersEditRef(banners.ref), NewDate);
        dispatch({
            type: BANNERS_EDIT,
            payload: NewDate,
        });

    }

};
